import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import auth from './authentication';

const httpCallBackEndTimeout:number = 15000;

function initApiClient(apiConfiguration: ApiConfigurationWithKey | ApiConfigurationWithKeyRef): AxiosInstance {
    const apiClient: AxiosInstance = axios.create({ baseURL: apiConfiguration.url });

    let apiKey: string;
    if ('apiKey' in apiConfiguration) {
        apiKey = apiConfiguration.apiKey;
    } else if ('apiKeyRef' in apiConfiguration) {
        apiKey = process.env[apiConfiguration.apiKeyRef];
    }

    apiClient.interceptors.request.use(
        (config) => setAuthToken(config).then(config => setApiKey(config, apiKey)),
        (error) => {
            return Promise.reject(error);
        }
    );

    return apiClient;
}

export const aromConnectorClient   : AxiosInstance = initApiClient(window.configuration.aromConnector);
export const eventsApiClient       : AxiosInstance = initApiClient(window.configuration.events);
export const fabricationApiClient  : AxiosInstance = initApiClient(window.configuration.fabrication);
export const preparationApiClient  : AxiosInstance = initApiClient(window.configuration.preparation);
export const pricesApiClient       : AxiosInstance = initApiClient(window.configuration.prices);
export const productsApiClient     : AxiosInstance = initApiClient(window.configuration.products);
export const storesApiClient       : AxiosInstance = initApiClient(window.configuration.stores);

function setAuthToken(config: AxiosRequestConfig<any>): Promise<AxiosRequestConfig<any>> {
    return auth.ensureFreshToken()
        .then((token) => {
            config.headers.Authorization = `Bearer ${token}`;
            if(!config.timeout) {
                config.timeout = httpCallBackEndTimeout;
            }
            return Promise.resolve(config);
        })
        .catch(() => {
            // token could not be refreshed, user might not be logged in.
            return Promise.resolve(config);
        });
}

function setApiKey(config: AxiosRequestConfig<any>, apiKey: string): Promise<AxiosRequestConfig<any>> {
    if (apiKey != null && apiKey !== '') {
        config.headers['X-Gravitee-Api-Key'] = apiKey;
    }

    return Promise.resolve(config);
}
